import {ProjectAccess} from "../../../gd/const/project"
import ProjectSession from "../project-session"

// const debug = "canCreateProject"
const debug = false

export default function canCreateProject(project:ProjectSession) {

    // cant add task to archived projects
    if (gd.const.systemStatus.isClosed(project.systemStatus)) return false

    // no tasks in tags
    if (project.systemType === gd.const.project.type.TAG) return false

    if (!project.isTemplate) {
        // this code is same as in gd.ac.project.canCreateTask
        // make sure project user exists
        const projectUser = gd.session.projectUsers.findByProjectAndUser(project.id, gd.user.id)

        debug && console.log(debug, 'process projectUser.access', projectUser?.access, project.name)

        if (!projectUser) return false

        // verify with projectAccess settings
        switch (projectUser.access) {
            case ProjectAccess.FULL:
                return true
            case ProjectAccess.STANDARD:
                return gd.company.settings.projectAccess.standard.createProject
            case ProjectAccess.LIMITED:
                return gd.company.settings.projectAccess.limited.createProject
            case ProjectAccess.CLIENT:
            case ProjectAccess.READ_ONLY:
                return false
            default:
                console.error("unknonw option #kkdja9221")
                return false
        }
    }

    return true
}